var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSend = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.097 6.608c-.532-1.684 1.221-3.18 2.801-2.391l19.999 9.995c1.474.737 1.474 2.841 0 3.578L6.898 27.785c-1.58.79-3.333-.707-2.8-2.392l2.967-9.392-2.968-9.393Zm4.749 10.393-2.842 8.995 19.999-9.995L6.004 6.006 8.846 15h6.874a1 1 0 1 1 0 2H8.846Z",
    fill: "#000"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSend);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/send.41611306c4eaabf27a1013ca5a8870ae.svg";